export const smartDocStaticParamType_Attribute = 'attribute';
//# sourceMappingURL=types.js.map